import React from "react";
//#region types
import { SalaryDeviationFormTypes } from "models/formTypes";
import { SalaryDeviationListContainerProps } from "models/propTypes/salaryDeviationPropTypes";
//#endregion
//#region components
import { useFilterContext } from "components/common";
import SalaryDeviationListView from "./listView";
import useSalaryDeviationHoverMoreActions from "./actions/useMoreActions";
//#endregion
import { DateHelper } from "utils/helpers";

const SalaryDeviationListContainer: React.FC<SalaryDeviationListContainerProps> = (props) => {
  const { reloadKey, reloadList, deviationMonth } = props;

  const { filter } = useFilterContext<SalaryDeviationFormTypes.Filter>();

  const filterYearMonth = filter?.yearAndMonth ? DateHelper.getYearMonth(filter.yearAndMonth) : undefined;
  const currentYearMonth = DateHelper.getYearMonth(DateHelper.today());

  const { getRowActions } = useSalaryDeviationHoverMoreActions(
    reloadList,
    filterYearMonth ?? currentYearMonth,
    deviationMonth
  );

  return (
    <SalaryDeviationListView
      tableId="salaryDeviationReportList"
      reloadKey={reloadKey}
      reloadList={reloadList}
      filter={filter}
      rowHoverActionsHandler={getRowActions}
      orderByProperty="hasDeviationsForPeriod"
      orderByDescending
      thenByProperty="personName"
      includePersonsWithNoDeviations
      deviationMonth={deviationMonth}
    ></SalaryDeviationListView>
  );
};

export default SalaryDeviationListContainer;
